var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"layout"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('vue-page-stack',[_c('router-view',{key:_vm.$route.fullPath,staticClass:"router-view-c"})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }